import {extendsAPIServices} from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import {GET, POST} from "../../constants/HTTPConstants";

const baseAdminAPI = getEnv('baseAdminAPI');
const api = extendsAPIServices(baseAdminAPI);

export const _setMembership = (args) => {
    return api.makeAuthRequest({
        method: POST,
        url: '/setPlan',
        data: args
    });
};

export const _getTotalEarning = () => {
    return api.makeAuthRequest({
        method: GET,
        url: `/earning`
    });
};

export const _getListUsers = ({page = 1, limit = 100, query}) => {
    return api.makeAuthRequest({
        method: POST,
        url: '/users',
        data: {
            page,
            limit,
            query
        }
    });
};

export const _switchUser = (userId) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/switch-user?id=${userId}`
    });
};

export const _getUserDetail = (userId) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/users/${userId}`
    });
};

export const _getAvailableRoles = (userId) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/users/roles/available`
    });
};

export const _getBillingHistory = (userId) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/users/${userId}/billing`
    });
};

export const _updateUserRoles = (userId, roles = []) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/users/${userId}/roles`,
        data: {
            roles
        }
    });
};

export const _setMembershipV2 = ({userId, price, finish}) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/users/membership`,
        data: {
            userId,
            price,
            finish
        }
    });
};


// WEBPACK FOOTER //
// ./src/services/apis/AdminServices.js